import { Repository } from '../../../core/context/repository';
import { type AttackerType } from './entity';

export class AttackerTypes extends Repository<AttackerType> {
    getTypes(): AttackerType[] {
        return this.items.filter((attackerType) => !attackerType.isActor);
    }

    getActors(): AttackerType[] {
        return this.items.filter((attackerType) => attackerType.isActor);
    }
}
